import { StockEntryTable } from "../components/modules/asset/purchase/stockentry/Add/Add";
import useLabels from "../customHooks/useLabels";
import {
  AMOUNT_TEXT_ALIGN,
  FlexForColumns,
  HEADER_TEXT_ALIGN,
  MARKS_TEXT_ALIGN,
  SLNO_TEXT_ALIGN,
} from "../styles/Variables";
import { TableHeaders } from "../utils/Enum.types";

const useAssetTableJson = () => {
  const {
    subsidiaryLabel,
    itemLabel,
    companyLabel,
    ledgerLabel,
    junctionLabel,
    subsidiarySiteLabel,
  } = useLabels();
  const tableJson = {
    Masters_Table: {
      Subsidary: [
        {
          headerName: "Sl",
          cellClassName: "number-cell",
          field: "id",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.SLNO,
        },
        {
          headerName: `Name`,
          cellClassName: "td-link",
          field: "company_name",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.DESCRIPTION,
          hideable: false,
        },
        {
          headerName: "Address",
          field: "company_addr",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.ADDRESS,
        },
        {
          headerName: "Email",
          field: "company_email",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.EMAIL,
        },
        {
          headerName: "Mobile",
          field: "company_mobile",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.MOBILE_NO,
        },
        {
          headerName: "Contact Person",
          field: "company_c_person",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.CONTACT_PERSON,
        },
      ],
      AssociationSubsidarySite: [
        {
          headerName: "Sl",
          cellClassName: "number-cell",
          field: "id",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.SLNO,
        },
        {
          headerName: "Site Name",
          cellClassName: "td-link",
          field: "company_name",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.DESCRIPTION,
          hideable: false,
        },
        {
          headerName: "Address",
          field: "company_addr",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.ADDRESS,
        },
        {
          headerName: "Email",
          field: "company_email",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.EMAIL,
        },
        {
          headerName: "Mobile",
          cellClassName: "nuber-cell",
          field: "company_mobile",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.MOBILE_NO,
        },
        {
          headerName: "Contact Person",
          field: "company_c_person",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.CONTACT_PERSON,
        },
      ],
       ItmsChallan: [
        {
          headerName: "Sl",
          cellClassName: "number-cell",
          field: "id",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.SLNO,
        },
        {
          headerName: `Date`,
          cellClassName: "td-link",
          field: "date",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.DESCRIPTION,
          hideable: false,
        },
          {
          headerName: `Challan Type`,
          cellClassName: "td-link",
          field: "challanType",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.DESCRIPTION,
          hideable: false,
        },
        {
          headerName: "Stop Line",
          field: "stopLine",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.ADDRESS,
        },
        {
          headerName: "Seat Belt",
          field: "seatBelt",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.EMAIL,
        },
        {
          headerName: "Jumping Signal",
          field: "jumpingSignal",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.MOBILE_NO,
        },
        {
          headerName: "Triple Ride",
          field: "tripleRide",
          headerAlign: HEADER_TEXT_ALIGN,
          align:SLNO_TEXT_ALIGN,
          flex: FlexForColumns.CONTACT_PERSON,
        },
        {
          headerName: "No Helmet",
          field: "noHelmet",
          headerAlign: HEADER_TEXT_ALIGN,
          align:SLNO_TEXT_ALIGN,
          flex: FlexForColumns.CONTACT_PERSON,
        },
         {
          headerName: "Over Speed",
          field: "overSpeed",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.CONTACT_PERSON,
        },
        {
          headerName: "Driver On Call",
          field: "driverOnCall",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.CONTACT_PERSON,
        },
         {
          headerName: "Total",
          field: "total",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.CONTACT_PERSON,
        },
      ],
      Masters: {
        Items: [
          {
            headerName: "Sl",
            cellClassName: "number-cell",
            field: "id",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.SLNO,
          },
          {
            headerName: "Description",
            field: "desc",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
            cellClassName: "td-link",
            hideable: false,
          },
          {
            headerName: `${itemLabel} Code`,
            field: "code",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.CODE,
          },
          {
            headerName: `${itemLabel} Group`,
            field: "item_group",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },
          {
            headerName: `${itemLabel} Category`,
            field: "item_category",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },
          {
            headerName: "Unit of Measurement",
            field: "unit_of_measurement",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },
          {
            headerName: "IGST Rate %",
            field: "igst",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.PERCENTAGE,
            cellClassName: "number-cell",
          },
          {
            headerName: "CGST Rate %",
            field: "cgst",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.PERCENTAGE,
            cellClassName: "number-cell",
          },
          {
            headerName: "SGST Rate %",
            field: "sgst",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.PERCENTAGE,
            cellClassName: "number-cell",
          },
        ],
        Supplier: [
          {
            headerName: "Sl",
            field: "id",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.SLNO,
            cellClassName: "number-cell",
          },
          {
            headerName: `${ledgerLabel} Name`,
            field: "desc",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
            cellClassName: "td-link",
            hideable: false,
          },
          {
            headerName: "GST No.",
            field: "gstNo",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.GST_N0,
            cellClassName: "number-cell",
          },
          {
            headerName: "City",
            field: "city",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.CITY,
          },
          {
            headerName: "State",
            field: "state",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.STATE,
          },
          {
            headerName: "Proficiency",
            field: "proficiency",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },
          {
            headerName: "Mobile No.",
            field: "phone",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.MOBILE_NO,
          },
          {
            headerName: "Contact Person",
            field: "contactPerson",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.CONTACT_PERSON,
          },
        ],
        MultipleLocation: [
          {
            headerName: "Sl",
            field: "id",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            cellClassName: "number-cell",
            flex: FlexForColumns.SLNO,
          },
          {
            headerName: "State",
            field: "state",
            headerAlign: HEADER_TEXT_ALIGN,
            hideable: false,
            flex: FlexForColumns.STATE,
          },
          {
            headerName: "Address",
            field: "addr",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.ADDRESS,
          },
          {
            headerName: "GST No.",
            field: "gstNo",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.GST_N0,
            cellClassName: "number-cell",
          },
        ],
        ItemConfigurations: [
          {
            headerName: "Sl",
            field: "id",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.SLNO,
            cellClassName: "number-cell",
          },
          {
            headerName: "Predefined Description",
            field: "predefined_desc",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
            hideable: false,
          },
          {
            headerName: "Actions",
            field: "actions",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.ACTION_BUTTON,
          },
        ],
        Association: {
          SupplierToItem: [
            {
              headerName: "Sl",
              field: "id",
              headerAlign: HEADER_TEXT_ALIGN,
              align: SLNO_TEXT_ALIGN,
              FlexForColumns: FlexForColumns.SLNO,
              cellClassName: "number-cell",
            },
            {
              headerName: `${itemLabel} Code`,
              field: "code",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.CODE,
            },
            {
              headerName: "Description",
              field: "desc",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.DESCRIPTION,
              hideable: false,
            },

            {
              headerName: `${itemLabel} Group`,
              field: "item_group",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.CODE,
            },
            {
              headerName: `${itemLabel} Category`,
              field: "item_category",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.SUB_DESC,
            },

            {
              headerName: `Total Associated ${ledgerLabel}`,
              field: "ldgr_count",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.NUMBER,
              cellclassName: "number-cell",
            },
            {
              headerName: "Actions",
              field: "actions",
              headerAlign: HEADER_TEXT_ALIGN,
              align: SLNO_TEXT_ALIGN,
              flex: FlexForColumns.ACTION,
            },
          ],
          Assign: [
            {
              headerName: "Sl",
              field: "id",
              headerAlign: HEADER_TEXT_ALIGN,
              align: SLNO_TEXT_ALIGN,
              flex: FlexForColumns.SLNO,
              cellClassName: "number-cell",
            },
            {
              headerName: `${ledgerLabel} Name`,
              field: "desc",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.DESCRIPTION,
              hideable: false,
              cellClassName: "td-link",
            },
            {
              headerName: "GST No.",
              field: "gstNo",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.GST_N0,
            },
            {
              headerName: "City",
              field: "city",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.CITY,
            },
            {
              headerName: "State",
              field: "state",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.STATE,
            },
            {
              headerName: "Proficiency",
              field: "proficiency",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.SUB_DESC,
            },
          ],
        },
        AssociationItems: {
          Assign: [
            {
              headerName: "Sl",
              field: "id",
              headerAlign: HEADER_TEXT_ALIGN,
              align: SLNO_TEXT_ALIGN,
              cellClassName: "number-cell",
              flex: FlexForColumns.SLNO,
            },
            {
              headerName: `${itemLabel} Code`,
              field: "code",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.CODE,
            },
            {
              headerName: "Description",
              field: "desc",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.DESCRIPTION,
              hideable: false,
              cellClassName: "td-link",
            },

            {
              headerName: `${itemLabel} Group`,
              field: "item_group",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.DESCRIPTION,
            },
            {
              headerName: `${itemLabel} Category`,
              field: "item_category",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.DESCRIPTION,
            },
            {
              headerName: `Total Associated ${ledgerLabel}`,
              field: "ldgr_count",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.NUMBER,
              cellClassName: "number-cell",
            },
          ],
          ItemToSupplier: [
            {
              headerName: "Sl",
              field: "id",
              headerAlign: HEADER_TEXT_ALIGN,
              align: SLNO_TEXT_ALIGN,
              flex: FlexForColumns.SLNO,
              cellClassName: "number-cell",
            },
            {
              headerName: `${ledgerLabel} Name`,
              field: "desc",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.DESCRIPTION,
              hideable: false,
              cellClassName: "td-link",
            },
            {
              headerName: "GST No.",
              field: "gstNo",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.GST_N0,
              cellClassName: "number-cell",
            },
            {
              headerName: "City",
              field: "city",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.CITY,
            },
            {
              headerName: "State",
              field: "state",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.STATE,
            },
            {
              headerName: "Proficiency",
              field: "proficiency",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.SUB_DESC,
            },
            {
              headerName: "Actions",
              field: "actions",
              headerAlign: HEADER_TEXT_ALIGN,
              align: SLNO_TEXT_ALIGN,
              flex: FlexForColumns.ACTION_BUTTON,
            },
          ],
        },
        AssociationSites: {
          Assign: [
            {
              headerName: "Sl",
              field: "id",
              headerAlign: HEADER_TEXT_ALIGN,
              align: SLNO_TEXT_ALIGN,
              flex: FlexForColumns.SLNO,
              cellClassName: "number-cell",
            },
            {
              headerName: "Site Id",
              field: "siteID",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.CODE,
              cellClassName: "number-cell",
            },
            {
              headerName: "Description",
              field: "desc",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.DESCRIPTION,
              hideable: false,
              cellClassName: "td-link",
            },
            {
              headerName: "City",
              field: "city",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.CITY,
            },
            {
              headerName: "State",
              field: "state",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.STATE,
            },
          ],
          SiteToVendor: [
            {
              headerName: "Sl",
              field: "id",
              headerAlign: HEADER_TEXT_ALIGN,
              align: SLNO_TEXT_ALIGN,
              flex: FlexForColumns.SLNO,
              cellClassName: "number-cell",
            },
            {
              headerName: `${ledgerLabel} Name`,
              field: "desc",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.DESCRIPTION,
              hideable: false,
              cellClassName: "td-link",
            },
            {
              headerName: "GST No.",
              field: "gstNo",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.GST_N0,
              cellClassName: "number-cell",
            },
            {
              headerName: "City",
              field: "city",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.CITY,
            },
            {
              headerName: "State",
              field: "state",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.STATE,
            },
            {
              headerName: "Proficiency",
              field: "proficiency",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.SUB_DESC,
            },
            {
              headerName: "Actions",
              field: "actions",
              headerAlign: HEADER_TEXT_ALIGN,
              align: SLNO_TEXT_ALIGN,
              flex: FlexForColumns.ACTION_BUTTON,
            },
          ],
        },
        Grouping: {
          List: [
            {
              headerName: "Sl",
              field: "id",
              headerAlign: HEADER_TEXT_ALIGN,
              align: SLNO_TEXT_ALIGN,
              cellClassName: "number-cell",
            },
            {
              headerName: `Item Group Description`,
              field: "group_name",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.DESCRIPTION,
              hideable: false,
            },
            {
              headerName: `Actions`,
              field: "actions",
              headerAlign: HEADER_TEXT_ALIGN,
              align: SLNO_TEXT_ALIGN,
              flex: FlexForColumns.SUB_DESC,
            },
          ],
          Asset: [
            {
              headerName: "Sl",
              field: "id",
              headerAlign: HEADER_TEXT_ALIGN,
              align: SLNO_TEXT_ALIGN,
              cellClassName: "number-cell",
            },
            {
              headerName: `Grouping Name`,
              field: "grouping_name",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.DESCRIPTION,
              hideable: false,
            },
            {
              headerName: `${itemLabel} List`,
              field: "asset_list",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.SUB_DESC,
            },
            {
              headerName: `Total No. of ${itemLabel}'s`,
              field: "total_assets",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.SUB_DESC,
              align: SLNO_TEXT_ALIGN,
            },
            {
              headerName: `Actions`,
              field: "actions",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.SUB_DESC,
              align: SLNO_TEXT_ALIGN,
            },
          ],
          AddAsset: [
            {
              labelName: "Sl",
              className: "grouping-asset__add--table--slno",
            },
            {
              labelName: `${itemLabel}'s`,
              className: "grouping-asset__add--table--desc",
            },
            {
              labelName: `${itemLabel} Code`,
              className: "grouping-asset__add--table--code",
            },
            {
              labelName: `No of ${itemLabel}`,
              className: "grouping-asset__add--table--code",
            },
            {
              labelName: `Actions`,
              className: "grouping-asset__add--table--actions",
            },
          ],
          AssociateAssetDetails: [
            {
              labelName: "Sl",
              className: "grouping-asset__add--table--slno",
            },
            {
              labelName: `${itemLabel}'s`,
              className: "grouping-asset__add--table--desc",
            },
            {
              labelName: `No of ${itemLabel}`,
              className: "grouping-asset__add--table--code",
            },
            {
              labelName: `${itemLabel} Details`,
              className: "grouping-asset__add--table--code",
            },
            {
              labelName: `${itemLabel} Choosen`,
              className: "grouping-asset__add--table--code",
            },
            {
              labelName: `${itemLabel} Remaining`,
              className: "grouping-asset__add--table--code",
            },
          ],
        },
      },
      FinancialYear: [
        { labelName: "Sl", className: "institution__table--th-slno" },
        { labelName: "Year", className: "institution__table--th-year" },
        {
          labelName: "Start Date",
          className: "institution__table--th-date",
        },
        {
          labelName: "End Date",
          className: "institution__table--th-date",
        },
      ],
    },
    JunctionsTable: {
      List: [
        {
          headerName: "Sl",
          cellClassName: "number-cell",
          field: "id",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.SLNO,
        },
        {
          headerName: `Name`,
          cellClassName: "td-link",
          field: "junction_name",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.DESCRIPTION,
          hideable: false,
        },
        {
          headerName: "Code",
          field: "code",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.CODE,
        },
        {
          headerName: "Vendor",
          field: "vendorDetails",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.CODE,
        },
        {
          headerName: "Alias",
          field: "alias",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.CODE,
        },
        {
          headerName: "Junction Type",
          field: "jType",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.CODE,
        },
        {
          headerName: "Junction Status",
          field: "junctionStatus",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.CODE,
        },
        {
          headerName: "Arms",
          field: "arms",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.CODE,
        },
        {
          headerName: "Poles",
          field: "poles",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.CODE,
        },
        {
          headerName: "Priority",
          field: "priority",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.CODE,
        },
        {
          headerName: "Geo Validated",
          field: "isLocValidated",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "center",
          flex: FlexForColumns.CODE,
        },
      ],
    },
    Purchase: {
      Add: [
        {
          headerName: "Sl",
          flex: FlexForColumns.SLNO,
          cellClassName: "number-cell",
          field: "id",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
        },
        {
          headerName: "Date",
          field: "date",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.DATE,
          cellClassName: "number-cell",
        },
        {
          headerName: "Invoice No",
          field: "invoice_no",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.CODE,
          cellClassName: "number-cell",
        },
        {
          headerName: `${ledgerLabel} Name`,
          field: "supplier_name",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.DESCRIPTION,
          hideable: false,
        },
        {
          headerName: "GST No.",
          field: "gstNo",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.GST_N0,
        },
        {
          headerName: "Taxable Amount",
          field: "taxable_amt",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.AMOUNT,
          cellClassName: "number-cell",
        },
        {
          headerName: "Tax Amount",
          field: "tax_amt",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.AMOUNT,
          cellClassName: "number-cell",
        },
        {
          headerName: "Total",
          field: "total",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.AMOUNT,
          cellClassName: "number-cell",
        },
        {
          headerName: "Discount Amount",
          field: "discount_amt",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.AMOUNT,
          cellClassName: "number-cell",
        },
        {
          headerName: "Fright/Extra Charges",
          field: "fright_charges",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.AMOUNT,
          cellClassName: "number-cell",
        },
        {
          headerName: "Net Total",
          field: "net_total",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.AMOUNT,
          cellClassName: "number-cell",
        },
      ],

      Material: {
        Add: [
          {
            headerName: "Sl",
            field: "id",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.SLNO,
            cellClassName: "number-cell",
          },
          {
            headerName: `${itemLabel} Code/Name`,
            field: "item_code",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.CODE,
            hideable: false,
          },
          {
            headerName: "UOM",
            field: "uom",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },

          {
            headerName: "Description",
            field: "description",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
          },
          {
            headerName: "Present Stock",
            field: "present_stock",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Required Qty",
            field: "required_qty",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Approx Rate",
            field: "approx_rate",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.AMOUNT,
            cellClassName: "number-cell",
          },
          {
            headerName: "Delivery Rate",
            field: "delivery_rate",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.AMOUNT,
            cellClassName: "number-cell",
          },
          {
            headerName: "Installation Rate",
            field: "installation_rate",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.AMOUNT,
            cellClassName: "number-cell",
          },
          {
            headerName: "Others Rate",
            field: "others_rate",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.AMOUNT,
            cellClassName: "number-cell",
          },
          {
            headerName: "Taxable Value",
            field: "taxable_amt",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Tax %",
            field: "tax",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Net Value",
            field: "net_value",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Priority",
            field: "priority",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },
          {
            headerName: "Need Before",
            field: "need_before",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
            cellClassName: "number-cell",
          },
          {
            headerName: `Prefered ${ledgerLabel}`,
            field: "prefered_vendor",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },
          {
            headerName: "Used For",
            field: "used_for",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },

          {
            headerName: "Remark",
            field: "remark",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
          },

          {
            headerName: "Actions",
            field: "actions",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.ACTION_BUTTON,
          },
        ],
        Assign: [
          {
            headerName: `${ledgerLabel} Name`,
            field: "supplier_name",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
            hideable: false,
          },
          {
            headerName: "GST No.",
            field: "gstNo",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.GST_N0,
            cellClassName: "number-cell",
          },
          {
            headerName: "City",
            field: "city",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.CITY,
          },
          {
            headerName: "State",
            field: "state",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.STATE,
          },
          {
            headerName: "Proficiency",
            field: "proficiency",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },
          {
            headerName: "Mobile No.",
            field: "mobile_no",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.MOBILE_NO,
          },
          {
            headerName: "Contact Person",
            field: "contact_person",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.CONTACT_PERSON,
          },
        ],

        View: [
          {
            headerName: "Sl",
            field: "id",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.SLNO,
            cellClassName: "number-cell",
          },
          {
            headerName: `${itemLabel} Code / Name`,
            field: "item_code",
            headerAlign: HEADER_TEXT_ALIGN,
            hideable: false,
            flex: FlexForColumns.DESCRIPTION,
          },
          {
            headerName: "UOM",
            field: "uom",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
            cellClassName: "number-cell",
          },

          {
            headerName: "Description",
            field: "description",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
            cellClassName: "number-cell",
          },
          {
            headerName: "Present Stock",
            field: "present_stock",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Required Qty",
            field: "required_qty",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Approx Rate",
            field: "approx_rate",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.PERCENTAGE,
            cellClassName: "number-cell",
          },
          {
            headerName: "Taxable Value",
            field: "taxable_amt",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.PERCENTAGE,
            cellClassName: "number-cell",
          },
          {
            headerName: "Tax %",
            field: "tax",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Net Value",
            field: "net_value",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Priority",
            field: "priority",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },
          {
            headerName: "Need Before",
            field: "need_before",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DATE,
            cellClassName: "number-cell",
          },
          {
            headerName: `Prefered ${ledgerLabel}`,
            field: "prefered_vendor",
            headerAlign: HEADER_TEXT_ALIGN,
            cellClassName: "td-link",
            flex: FlexForColumns.SUB_DESC,
          },
          {
            headerName: "Used For",
            field: "used_for",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },

          {
            headerName: "Remark",
            field: "remark",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
          },
          {
            headerName: "Accepted Status",
            field: "accepted",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.STATUS,
          },
          {
            headerName: "Accepted Qty",
            field: "accepted_qty",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
          },
          // {
          //   headerName: "RFQ Date",
          //   field: "rfq_date",
          //   headerAlign: HEADER_TEXT_ALIGN,
          // },
          // {
          //   headerName: "RFQ Sent for (Supplier)",
          //   field: "rfq_sent",
          //   headerAlign: HEADER_TEXT_ALIGN,
          // },
          {
            headerName: "Remarks",
            field: "accepted_remark",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
          },
        ],
        MRFtoPo: [
          {
            headerName: "Sl",
            field: "id",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.SLNO,
            cellClassName: "number-cell",
          },
          {
            headerName: `${itemLabel} Code`,
            field: "item_code",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.CODE,
            cellClassName: "number-cell",
            hideable: false,
          },
          {
            headerName: "UOM",
            field: "uom",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },

          {
            headerName: "Description",
            field: "description",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
          },
          {
            headerName: "Present Stock",
            field: "present_stock",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Required Qty",
            field: "required_qty",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Approx Rate",
            field: "approx_rate",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.PERCENTAGE,
            cellClassName: "number-cell",
          },
          {
            headerName: "Taxable Value",
            field: "taxable_amt",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Tax %",
            field: "tax",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.PERCENTAGE,
            cellClassName: "number-cell",
          },
          {
            headerName: "Net Value",
            field: "net_value",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.PERCENTAGE,
            cellClassName: "number-cell",
          },
          {
            headerName: "Priority",
            field: "priority",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
          },
          {
            headerName: "Need Before",
            field: "need_before",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DATE,
            cellClassName: "number-cell",
          },
          {
            headerName: `Prefered ${ledgerLabel}`,
            field: "prefered_vendor",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.CONTACT_PERSON,
          },
          {
            headerName: "Used For",
            field: "used_for",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },

          {
            headerName: "Remark",
            field: "remark",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
          },
          {
            headerName: "Accepted Status",
            field: "accepted",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.STATUS,
          },
          {
            headerName: "Accepted Qty",
            field: "accepted_qty",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          // {
          //   headerName: "RFQ Date",
          //   field: "rfq_date",
          //   headerAlign: HEADER_TEXT_ALIGN,
          // },
          // {
          //   headerName: "RFQ Sent for (Supplier)",
          //   field: "rfq_sent",
          //   headerAlign: HEADER_TEXT_ALIGN,
          // },
          {
            headerName: "Remarks",
            field: "accepted_remark",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
          },
          {
            headerName: "Last Supplied by",
            field: "last_supplied_by",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },
          {
            headerName: "Last Supplied Qty",
            field: "last_supplied_qty",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
            cellClassName: "number-cell",
          },
          {
            headerName: "Last Supplied Rate",
            field: "last_supplied_rate",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
            cellClassName: "number-cell",
          },
          {
            headerName: "Ordered Rate",
            field: "ordered_rate",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
            cellClassName: "number-cell",
          },
          {
            headerName: `Order to ${ledgerLabel}`,
            field: "order_to_supplier",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },
          {
            headerName: "Remarks",
            field: "remarks",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
          },
          {
            headerName: "Actions",
            field: "actions",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.ACTION_BUTTON,
          },
        ],
      },
      Quotation: {
        List: [
          {
            headerName: "Sl",
            field: "id",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.SLNO,
            cellClassName: "number-cell",
          },
          {
            headerName: "RFQ Date",
            field: "rfq_date",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DATE,
            cellClassName: "number-cell",
          },
          {
            headerName: "Request for Quotation No.",
            field: "request_for_quotation_no",
            headerAlign: HEADER_TEXT_ALIGN,
            cellClassName: "td-link",
            flex: FlexForColumns.DESCRIPTION,
            hideable: false,
          },
          {
            headerName: `Total ${itemLabel} Quoted`,
            field: "total_items_quoted",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
            cellClassName: "number-cell",
          },
          {
            headerName: "Approx Value",
            field: "approx_value",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Last Date for Submission",
            field: "late_date_for_submission",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },
          {
            headerName: "RFQ Prepared by",
            field: "rfq_prepared_by",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },
          {
            headerName: "RFQ Authorized by",
            field: "rfq_authorized_by",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.CONTACT_PERSON,
          },
          {
            headerName: "Remarks",
            field: "remarks",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
          },
          {
            headerName: "Mail Status",
            field: "mail_status",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.STATUS,
          },
          {
            headerName: "Actions",
            field: "actions",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.ACTION_BUTTON,
          },
        ],
        Add: [
          {
            headerName: "Sl",
            field: "id",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.SLNO,
            cellClassName: "number-cell",
          },
          {
            headerName: "MRF No",
            field: "mrf",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.CODE,
            cellClassName: "number-cell",
            hideable: false,
          },
          {
            headerName: "MRF Date",
            field: "for_subsidary",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DATE,
            cellClassName: "number-cell",
          },
          {
            headerName: `${subsidiaryLabel}`,
            field: "subsidary",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },
          {
            headerName: `${itemLabel} Description`,
            field: "itm_desc",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },
          {
            headerName: "Description Send for RFQ",
            field: "cctv_camera",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },
          {
            headerName: "UOM",
            field: "uom",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },
          {
            headerName: "Present Stock",
            field: "presentStck",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },
          {
            headerName: "Approx Rate",
            field: "approxRate",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Accept Qty",
            field: "accptQty",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Approx Taxable Value",
            field: "taxable_value",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Tax",
            field: "tax",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Taxes Value",
            field: "net_value",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Approx Net Value",
            field: "approx_net_value",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: `RFQ ${ledgerLabel}`,
            field: "rfq_vendor",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },
          {
            headerName: "Terms",
            field: "terms",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },
          {
            headerName: "Payment Terms",
            field: "pymnt_terms",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },
          {
            headerName: "Remark",
            field: "remark",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
          },
        ],
        Approved: [
          {
            headerName: "Sl",
            field: "id",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.SLNO,
            cellClassName: "number-cell",
          },
          {
            headerName: `${itemLabel} Id`,
            field: "item_id",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.CODE,
            cellClassName: "number-cell",
          },
          {
            headerName: `${itemLabel} Description`,
            field: "item_desc",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
            hideable: false,
          },
          {
            headerName: `Total ${subsidiaryLabel} Requested Item`,
            field: "total_subsidiary",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
          },
          {
            headerName: "Total Quantity Requested",
            field: "total_quantity",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
          },
        ],
        Subsidiary: [
          {
            headerName: "Sl",
            field: "id",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.SLNO,
            cellClassName: "number-cell",
          },
          {
            headerName: "Material Request No.",
            field: "material_request_no",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: `Request from ${subsidiaryLabel}`,
            field: "request_from_subsidiary",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
            hideable: false,
          },
          {
            headerName: "Description sent on RFQ",
            field: "desc_sent_on_rfq",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },
          {
            headerName: "Requested Qty",
            field: "requested_qty",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },
          {
            headerName: "Accepted Qty",
            field: "accepted_qty",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },
          {
            headerName: "Priority",
            field: "priority",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },
          {
            headerName: "Need Before",
            field: "need_before",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.DATE,
            cellClassName: "number-cell",
          },
          {
            headerName: "RFQ Date",
            field: "rfq_date",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.DATE,
            cellClassName: "number-cell",
          },
          {
            headerName: `RFQ Sent for (${ledgerLabel})`,
            field: "rfq_sent_for",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },
          {
            headerName: "Remark",
            field: "remark",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
          },
        ],
        Login: {
          Preview: [
            {
              headerName: "Sl",
              field: "id",
              headerAlign: HEADER_TEXT_ALIGN,
              align: SLNO_TEXT_ALIGN,
              flex: FlexForColumns.SLNO,
              cellClassName: "number-cell",
            },
            {
              headerName: `${itemLabel} Description`,
              field: "item_desc",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.DESCRIPTION,
              hideable: false,
            },
            {
              headerName: "Required Qty",
              field: "required_qty",
              headerAlign: HEADER_TEXT_ALIGN,
              align: AMOUNT_TEXT_ALIGN,
              flex: FlexForColumns.SUB_DESC,
            },
            {
              headerName: "Terms",
              field: "terms",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.SUB_DESC,
            },
            {
              headerName: "Payment Terms",
              field: "payment_terms",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.SUB_DESC,
            },
            {
              headerName: "Remark",
              field: "remarks",
              headerAlign: HEADER_TEXT_ALIGN,

              flex: FlexForColumns.DESCRIPTION,
            },
          ],
          FillForm: [
            {
              headerName: "Sl",
              field: "id",
              headerAlign: HEADER_TEXT_ALIGN,
              align: SLNO_TEXT_ALIGN,
              flex: FlexForColumns.SLNO,
              cellClassName: "number-cell",
            },
            {
              headerName: `${itemLabel} Description`,
              field: "item_desc",
              headerAlign: HEADER_TEXT_ALIGN,
              hideable: false,
              flex: FlexForColumns.DESCRIPTION,
            },
            {
              headerName: "Required Qty",
              field: "required_qty",
              headerAlign: HEADER_TEXT_ALIGN,
              align: AMOUNT_TEXT_ALIGN,
              flex: FlexForColumns.NUMBER,
            },
            {
              headerName: "Terms",
              field: "terms",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.SUB_DESC,
            },
            {
              headerName: "Payment Terms",
              field: "payment_terms",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.SUB_DESC,
            },
            {
              headerName: "Interested to Quote",
              field: "interested_to_quote",
              headerAlign: HEADER_TEXT_ALIGN,
              align: SLNO_TEXT_ALIGN,
              flex: FlexForColumns.SUB_DESC,
            },
            {
              headerName: "if any Change in desc(Yes/no)",
              field: "if_any_change_in_desc",
              headerAlign: HEADER_TEXT_ALIGN,
              align: SLNO_TEXT_ALIGN,
              flex: FlexForColumns.SUB_DESC,
            },
            {
              headerName: "if any Change in desc Specify here",
              field: "if_any_change_in_desc_specify",
              headerAlign: HEADER_TEXT_ALIGN,
              align: SLNO_TEXT_ALIGN,
              flex: FlexForColumns.SUB_DESC,
            },
            {
              headerName: "Quoted Qty",
              field: "quoted_qty",
              headerAlign: HEADER_TEXT_ALIGN,
              align: AMOUNT_TEXT_ALIGN,
              flex: FlexForColumns.SUB_DESC,
            },
            {
              headerName: "Rate",
              field: "rate",
              headerAlign: HEADER_TEXT_ALIGN,
              align: AMOUNT_TEXT_ALIGN,
              flex: FlexForColumns.SUB_DESC,
            },
            {
              headerName: "Any other Charges per Qty",
              field: "any_other_charges_per_qty",
              headerAlign: HEADER_TEXT_ALIGN,
              align: SLNO_TEXT_ALIGN,
              flex: FlexForColumns.SUB_DESC,
            },
            {
              headerName: "Tax %",
              field: "tax_perc",
              headerAlign: HEADER_TEXT_ALIGN,
              align: AMOUNT_TEXT_ALIGN,
              flex: FlexForColumns.NUMBER,
            },
            {
              headerName: "Total Amount",
              field: "total_amount",
              headerAlign: HEADER_TEXT_ALIGN,
              align: AMOUNT_TEXT_ALIGN,
              cellClassName: "font-green",
              flex: FlexForColumns.NUMBER,
            },
            {
              headerName: "Delivery Charges",
              field: "delivery_charges",
              headerAlign: HEADER_TEXT_ALIGN,
              align: AMOUNT_TEXT_ALIGN,
              flex: FlexForColumns.SUB_DESC,
            },
            {
              headerName: "Installation Charges",
              field: "installation_charges",
              headerAlign: HEADER_TEXT_ALIGN,
              align: AMOUNT_TEXT_ALIGN,
              flex: FlexForColumns.NUMBER,
            },
            {
              headerName: "Net Quoted",
              field: "net_quoted",
              headerAlign: HEADER_TEXT_ALIGN,
              align: AMOUNT_TEXT_ALIGN,
              flex: FlexForColumns.NUMBER,
            },
            {
              headerName: "Remarks",
              field: "remarks",
              headerAlign: HEADER_TEXT_ALIGN,
              align: AMOUNT_TEXT_ALIGN,
              flex: FlexForColumns.DESCRIPTION,
            },

            {
              headerName: "Upload Product details",
              field: "upload_product_details",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.SUB_DESC,
            },
            {
              headerName: "Actions",
              field: "actions",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.ACTION_BUTTON,
            },
          ],
        },

        Comparision: {
          MQComparision: [
            {
              headerName: "Sl",
              field: "id",
              headerAlign: HEADER_TEXT_ALIGN,
              align: SLNO_TEXT_ALIGN,
              flex: FlexForColumns.SLNO,
              cellClassName: "number-cell",
            },
            {
              headerName: "RFQ Date",
              field: "rfq_date",
              headerAlign: HEADER_TEXT_ALIGN,
              align: SLNO_TEXT_ALIGN,
              flex: FlexForColumns.DATE,
              cellClassName: "number-cell",
            },
            {
              headerName: "RFQ No.",
              field: "rfq_no",
              headerAlign: HEADER_TEXT_ALIGN,
              hideable: false,
              flex: FlexForColumns.NUMBER,
              cellClassName: "number-cell",
            },
            {
              headerName: "Last Date for Submission",
              field: "last_date_for_submission",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.SUB_DESC,
              cellClassName: "number-cell",
            },
            {
              headerName: "RFQ Prepared By",
              field: "rfq_prepared_by",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.DESCRIPTION,
            },
            {
              headerName: "RFQ Authorized By",
              field: "rfq_authorized_by",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.DESCRIPTION,
            },
            {
              headerName: "Remarks",
              field: "remarks",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.DESCRIPTION,
            },
            {
              headerName: "RFQ Comparision Date",
              field: "rfq_comparision_date",
              headerAlign: HEADER_TEXT_ALIGN,
              align: SLNO_TEXT_ALIGN,
              flex: FlexForColumns.DATE,
              cellClassName: "number-cell",
            },
            {
              headerName: "Comparision Inspected By",
              field: "comparision_inspected_by",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.CONTACT_PERSON,
            },
            {
              headerName: "Comparision Remarks",
              field: "comparision_remarks",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.DESCRIPTION,
            },
            {
              headerName: "Finalized Quotation",
              field: "finalized_quotation",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.DESCRIPTION,
            },
            {
              headerName: "Actions",
              field: "actions",
              headerAlign: HEADER_TEXT_ALIGN,
              align: SLNO_TEXT_ALIGN,
              flex: FlexForColumns.ACTION_BUTTON,
            },
          ],
          Negotiation: [
            {
              headerName: "Sl",
              field: "id",
              headerAlign: HEADER_TEXT_ALIGN,
              align: SLNO_TEXT_ALIGN,
              flex: FlexForColumns.SLNO,
              cellClassName: "number-cell",
            },
            {
              headerName: `${itemLabel} Description`,
              field: "item_desc",
              headerAlign: HEADER_TEXT_ALIGN,
              hideable: false,
              flex: FlexForColumns.DESCRIPTION,
            },

            {
              headerName: "Required Qty",
              field: "required_quantity",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.SUB_DESC,
            },
            {
              headerName: "Terms",
              field: "terms",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.SUB_DESC,
            },
            {
              headerName: "Payment Terms",
              field: "payment_terms",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.SUB_DESC,
            },
            {
              headerName: "Sl",
              field: "vendor_sl",
              headerAlign: HEADER_TEXT_ALIGN,
              align: SLNO_TEXT_ALIGN,
              flex: FlexForColumns.SLNO,
              cellClassName: "number-cell",
            },
            {
              headerName: "Quoted Qty",
              field: "quoted_qty",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.NUMBER,
              cellClassName: "number-cell",
            },
            {
              headerName: "Rate",
              field: "rate",
              headerAlign: HEADER_TEXT_ALIGN,
              align: AMOUNT_TEXT_ALIGN,
              flex: FlexForColumns.NUMBER,
              cellClassName: "number-cell",
            },
            {
              headerName: "Any Other Charges Per Qty",
              field: "any_other_charges",
              headerAlign: HEADER_TEXT_ALIGN,
              align: AMOUNT_TEXT_ALIGN,
              flex: FlexForColumns.SUB_DESC,
              cellClassName: "number-cell",
            },
            {
              headerName: "Tax %",
              field: "tax_perc",
              headerAlign: HEADER_TEXT_ALIGN,
              align: AMOUNT_TEXT_ALIGN,
              flex: FlexForColumns.PERCENTAGE,
              cellClassName: "number-cell",
            },
            {
              headerName: "Total Amount",
              field: "total_amount",
              headerAlign: HEADER_TEXT_ALIGN,
              align: AMOUNT_TEXT_ALIGN,
              flex: FlexForColumns.AMOUNT,
              cellClassName: "number-cell",
            },
            {
              headerName: "Others",
              field: "others",
              headerAlign: HEADER_TEXT_ALIGN,
              align: AMOUNT_TEXT_ALIGN,
              flex: FlexForColumns.SUB_DESC,
            },
            {
              headerName: "Net Quoted",
              field: "net_quoted",
              headerAlign: HEADER_TEXT_ALIGN,
              cellClassName: "total-count number-cell",
              align: AMOUNT_TEXT_ALIGN,
              flex: FlexForColumns.AMOUNT,
            },
            {
              headerName: "Remarks",
              field: "remarks",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.DESCRIPTION,
            },
            {
              headerName: "Upload Product details",
              field: "upload_product_details",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.DESCRIPTION,
            },
            {
              headerName: "Place Order",
              field: "place_order",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.SUB_DESC,
            },
            {
              headerName: "Verbal Final Rate",
              field: "verbal_final_rate",
              headerAlign: HEADER_TEXT_ALIGN,
              align: AMOUNT_TEXT_ALIGN,
              flex: FlexForColumns.NUMBER,
              cellClassName: "number-cell",
            },
            {
              headerName: "taxes",
              field: "taxes",
              headerAlign: HEADER_TEXT_ALIGN,
              align: AMOUNT_TEXT_ALIGN,
              flex: FlexForColumns.NUMBER,
              cellClassName: "number-cell",
            },
            {
              headerName: "Order Qty",
              field: "order_qty",
              headerAlign: HEADER_TEXT_ALIGN,
              align: AMOUNT_TEXT_ALIGN,
              flex: FlexForColumns.NUMBER,
              cellClassName: "number-cell",
            },
            {
              headerName: "Verbal Final Amount",
              field: "verbal_final_amount",
              headerAlign: HEADER_TEXT_ALIGN,
              align: AMOUNT_TEXT_ALIGN,
              flex: FlexForColumns.AMOUNT,
              cellClassName: "number-cell",
            },
            {
              headerName: "Negotiation By",
              field: "negotiation_by",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.SUB_DESC,
            },
            {
              headerName: "Negotiation",
              field: "negotiation",
              headerAlign: HEADER_TEXT_ALIGN,
              flex: FlexForColumns.SUB_DESC,
            },
          ],
        },
      },
      PurchaseOrder: {
        List: [
          {
            headerName: "Sl",
            cellClassName: "number-cell",
            field: "id",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.SLNO,
          },
          {
            headerName: "PO Date",
            field: "po_date",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DATE,
            align: SLNO_TEXT_ALIGN,
          },
          {
            headerName: "PO No.",
            field: "po_no",
            headerAlign: HEADER_TEXT_ALIGN,
            hideable: false,
            flex: FlexForColumns.NUMBER,
            cellClassName: "td-link number-cell",
          },
          {
            headerName: `${ledgerLabel}`,
            field: "order_to_supplier",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
          },
          {
            headerName: `Total ${itemLabel}`,
            field: "total_items_ordered",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Total Qty",
            field: "total_qty_ordered",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Net Total",
            field: "net_total",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Remarks",
            field: "remarks",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
          },
          {
            headerName: "PO_form",
            field: "po_form",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
          },
          {
            headerName: "Actions",
            field: "actions",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.ACTION_BUTTON,
          },
        ],
        MrfToPo: [
          {
            headerName: "Sl",
            field: "id",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.SLNO,
            cellClassName: "number-cell",
          },
          {
            headerName: "Approved MRF No.",
            flex: FlexForColumns.SUB_DESC,
            field: "approved_mrf_no",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            hideable: false,
          },
          {
            headerName: "MRF Date",
            field: "mrf_date",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.DATE,
            cellClassName: "number-cell",
          },
          {
            headerName: "MRF Sl No.",
            field: "mrf_sl_no",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.SLNO,
            cellClassName: "number-cell",
          },
          {
            headerName: `${itemLabel} Description (RFQ Description) Approved ${itemLabel}`,
            field: "item_desc",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
          },
          {
            headerName: `${itemLabel} UOM`,
            field: "itemUom",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },
          // {
          //   headerName: "Warranty",
          //   field: "warranty",
          //   headerAlign: HEADER_TEXT_ALIGN,
          // },
          {
            headerName: "Quantity",
            field: "qty",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Rate",
            field: "rate",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Other Charges",
            field: "other_charges",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Taxable Rate",
            field: "taxable_rate",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Tax %",
            field: "tax_perc",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.PERCENTAGE,
            cellClassName: "number-cell",
          },
          {
            headerName: "Total",
            field: "total",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Any Installation",
            field: "any_installation",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },
          {
            headerName: "Delivery Charges",
            field: "delivery_charges",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.AMOUNT,
            cellClassName: "number-cell",
          },
          {
            headerName: "Delivery Date",
            field: "delivery_date",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.DATE,
            cellClassName: "number-cell",
          },
          {
            headerName: "NET Total",
            field: "net_total",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            cellClassName: "font-green number-cell",
            flex: FlexForColumns.NUMBER,
          },
          {
            headerName: "Action",
            field: "actions",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.ACTION_BUTTON,
          },
        ],
        MrfDetails: [
          {
            headerName: "Sl",
            field: "id",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.SLNO,
            cellClassName: "number-cell",
          },
          {
            headerName: "MRF No.",
            field: "mrf_no",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "MRF Date",
            field: "mrf_date",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DATE,
            cellClassName: "number-cell",
          },
          {
            headerName: `${subsidiaryLabel}`,
            field: "subsidiary",
            headerAlign: HEADER_TEXT_ALIGN,
            hideable: false,
            flex: FlexForColumns.DESCRIPTION,
          },
          {
            headerName: `Total ${itemLabel} Accepted`,
            field: "total_item_accepted",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Total Quantity Accepted",
            field: "total_quantity_accepted",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Approx Net Value",
            field: "approx_net_value",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Acceptance made by",
            field: "acceptance_made_by",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.CONTACT_PERSON,
          },
          {
            headerName: "Remarks",
            field: "remarks",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
          },
          {
            headerName: "Actions",
            field: "actions",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.ACTION_BUTTON,
          },
        ],
        MrfItems: [
          {
            headerName: "Sl",
            cellClassName: "number-cell",
            field: "id",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.SLNO,
          },
          {
            headerName: `${itemLabel} Description`,
            field: "item_desc",
            headerAlign: HEADER_TEXT_ALIGN,
            hideable: false,
            flex: FlexForColumns.DESCRIPTION,
          },
          {
            headerName: "Warranty",
            field: "warranty",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },
          {
            headerName: "Qty",
            field: "qty",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
          },
          {
            headerName: "Rate",
            field: "rate",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
          },
          {
            headerName: "Other Charges",
            field: "other_charges",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
          },
          {
            headerName: "Taxable Rate",
            field: "taxable_rate",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Tax %",
            field: "tax_perc",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.PERCENTAGE,
            cellClassName: "number-cell",
          },
          {
            headerName: "Total",
            field: "total",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Any Installtion / others",
            field: "any_installation",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },
          {
            headerName: "Net Total",
            field: "net_total",
            cellClassName: "total-count number-cell",
            align: AMOUNT_TEXT_ALIGN,
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
          },
          {
            headerName: "Actions",
            field: "actions",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.ACTION_BUTTON,
          },
        ],
        RfqToPo: [
          {
            headerName: "Sl",
            field: "id",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Approved RFQ No.",
            field: "approved_rfq_no",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            hideable: false,
            flex: FlexForColumns.NUMBER,
          },
          {
            headerName: "RFQ Date",
            field: "rfq_date",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.DATE,
            cellClassName: "number-cell",
          },
          {
            headerName: "RFQ Sl No.",
            field: "rfq_sl_no",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.SLNO,
            cellClassName: "number-cell",
          },
          {
            headerName: `${itemLabel} Description (RFQ Description) Approved ${itemLabel}`,
            field: "item_desc",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
          },
          {
            headerName: `${itemLabel} UOM`,
            field: "itemUom",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },
          {
            headerName: "Warranty",
            field: "warranty",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Quantity",
            field: "qty",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Rate",
            field: "rate",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Other Charges",
            field: "other_charges",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.AMOUNT,
            cellClassName: "number-cell",
          },
          {
            headerName: "Taxable Rate",
            field: "taxable_rate",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.AMOUNT,
            cellClassName: "number-cell",
          },
          {
            headerName: "Tax %",
            field: "tax_perc",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.PERCENTAGE,
            cellClassName: "number-cell",
          },
          {
            headerName: "Total",
            field: "total",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Installation Charges",
            field: "any_installation",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.AMOUNT,
            cellClassName: "number-cell",
          },
          {
            headerName: "Delivery Charges",
            field: "delivery_charges",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.AMOUNT,
            cellClassName: "number-cell",
          },
          {
            headerName: "Delivery Date",
            field: "deliveryDate",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.DATE,
            cellClassName: "number-cell",
          },
          {
            headerName: "NET Total",
            field: "net_total",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            cellClassName: "font-green number-cell",
            flex: FlexForColumns.NUMBER,
          },
          {
            headerName: "Action",
            field: "actions",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.ACTION_BUTTON,
          },
        ],
        RfqDetails: [
          {
            headerName: "Sl",
            cellClassName: "number-cell",
            field: "id",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.SLNO,
          },
          {
            headerName: "RFQ No.",
            field: "rfq_no",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "RFQ Date",
            field: "rfq_date",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DATE,
            cellClassName: "number-cell",
          },
          {
            headerName: subsidiaryLabel,
            field: "subsidiary",
            headerAlign: HEADER_TEXT_ALIGN,
            hideable: false,
            flex: FlexForColumns.DESCRIPTION,
          },
          {
            headerName: `Total ${itemLabel} Accepted`,
            field: "total_item_accepted",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Total Quantity Accepted",
            field: "total_quantity_accepted",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Approx Net Value",
            field: "approx_net_value",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "RFQ Authorized By",
            field: "rfq_authorized_by",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.CONTACT_PERSON,
          },
          {
            headerName: "Remarks",
            field: "remarks",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
          },
          {
            headerName: "Actions",
            field: "actions",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.ACTION_BUTTON,
          },
        ],
        RfqItems: [
          {
            headerName: "Sl",
            cellClassName: "number-cell",
            field: "id",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.SLNO,
          },
          {
            headerName: `${itemLabel}(RFQ) Description`,
            field: "item_desc",
            headerAlign: HEADER_TEXT_ALIGN,
            hideable: false,
            flex: FlexForColumns.DESCRIPTION,
          },
          {
            headerName: "Warranty",
            field: "warranty",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Qty",
            field: "qty",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Rate",
            field: "rate",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Other Charges",
            field: "other_charges",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.AMOUNT,
            cellClassName: "number-cell",
          },
          {
            headerName: "Taxable Rate",
            field: "taxable_rate",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.AMOUNT,
            cellClassName: "number-cell",
          },
          {
            headerName: "Tax %",
            field: "tax_perc",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.PERCENTAGE,
            cellClassName: "number-cell",
          },
          {
            headerName: "Total",
            field: "total",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Any Installtion / others",
            field: "any_installation",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },
          {
            headerName: "Net Total",
            field: "net_total",
            cellClassName: "total-count number-cell",
            align: AMOUNT_TEXT_ALIGN,
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
          },
          {
            headerName: "Actions",
            field: "actions",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.ACTION_BUTTON,
          },
        ],
      },
      StockEntry: {
        withoutPurchaseEntry: [
          {
            headerName: "Sl",
            cellClassName: "number-cell",
            field: "id",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.SLNO,
          },
          {
            headerName: "Date",
            field: "date",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DATE,
            cellClassName: "number-cell",
          },
          {
            headerName: "Reference No.",
            field: "ref_no",
            headerAlign: HEADER_TEXT_ALIGN,
            hideable: false,
            flex: FlexForColumns.DESCRIPTION,
            cellClassName: "td-link number-cell",
          },
          {
            headerName: "Code",
            field: "code",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.CODE,
            cellClassName: "number-cell",
          },
          {
            headerName: "Description",
            field: "description",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
          },
          {
            headerName: `${ledgerLabel}`,
            field: "supplier",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
          },
          {
            headerName: "Supplied Date",
            field: "supplied_date",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DATE,
            cellClassName: "number-cell",
          },
          {
            headerName: "Supplied Qty",
            field: "supplied_qty",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Supplied Rate",
            field: "supplied_rate",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Actions",
            field: "actions",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.ACTION_BUTTON,
          },
        ],
        Add: {
          SubHeader: [
            {
              headerName: "Sl No.",
              field: StockEntryTable.SL_No,
              headerAlign: HEADER_TEXT_ALIGN,
              align: SLNO_TEXT_ALIGN,
              hideable: false,
              flex: FlexForColumns.SLNO,
              cellClassName: "number-cell",
            },
            {
              headerName: "Serial No.",
              field: StockEntryTable.Serial_No,
              headerAlign: HEADER_TEXT_ALIGN,
              align: SLNO_TEXT_ALIGN,
              hideable: false,
              flex: FlexForColumns.NUMBER,
              cellClassName: "number-cell",
            },
            {
              headerName: "Batch.",
              field: StockEntryTable.Batch,
              headerAlign: HEADER_TEXT_ALIGN,
              hideable: false,
              flex: FlexForColumns.NUMBER,
            },
            {
              headerName: "Expiry",
              field: StockEntryTable.Expiry,
              headerAlign: HEADER_TEXT_ALIGN,
              hideable: false,
              flex: FlexForColumns.DATE,
              cellClassName: "number-cell",
            },
            {
              headerName: "Warranty",
              field: StockEntryTable.Warranty,
              headerAlign: HEADER_TEXT_ALIGN,
              hideable: false,
              flex: FlexForColumns.NUMBER,
              cellClassName: "number-cell",
            },
            {
              headerName: "Start Date",
              field: StockEntryTable.Warranty_Start_Date,
              headerAlign: HEADER_TEXT_ALIGN,
              hideable: false,
              flex: FlexForColumns.DATE,
              cellClassName: "number-cell",
            },
            {
              headerName: "End Date",
              field: StockEntryTable.Warranty_End_Date,
              headerAlign: HEADER_TEXT_ALIGN,
              hideable: false,
              flex: FlexForColumns.DATE,
              cellClassName: "number-cell",
            },

            {
              headerName: "Maintained By",
              field: StockEntryTable.Maintained_By,
              headerAlign: HEADER_TEXT_ALIGN,
              hideable: false,
              flex: FlexForColumns.SUB_DESC,
            },
            {
              headerName: "AMC Enabled",
              field: StockEntryTable.AMC_Enabled,
              headerAlign: HEADER_TEXT_ALIGN,
              hideable: false,
              flex: FlexForColumns.STATUS,
            },

            {
              headerName: "AMC",
              field: StockEntryTable.AMC,
              headerAlign: HEADER_TEXT_ALIGN,
              hideable: false,
              flex: FlexForColumns.NUMBER,
            },
            {
              headerName: "Start Date",
              field: StockEntryTable.AMC_Start_Date,
              headerAlign: HEADER_TEXT_ALIGN,
              hideable: false,
              flex: FlexForColumns.DATE,
              cellClassName: "number-cell",
            },
            {
              headerName: "End Date",
              field: StockEntryTable.AMC_End_Date,
              headerAlign: HEADER_TEXT_ALIGN,
              hideable: false,
              flex: FlexForColumns.DATE,
              cellClassName: "number-cell",
            },

            {
              headerName: "Geo Location",
              field: StockEntryTable.Geo_Location,
              headerAlign: HEADER_TEXT_ALIGN,
              hideable: false,
              flex: FlexForColumns.DESCRIPTION,
            },
            {
              headerName: "Insurance",
              field: StockEntryTable.Insurance,
              headerAlign: HEADER_TEXT_ALIGN,
              hideable: false,
              flex: FlexForColumns.DESCRIPTION,
            },
            {
              headerName: "Start Date.",
              field: StockEntryTable.INC_Start_Date,
              headerAlign: HEADER_TEXT_ALIGN,
              hideable: false,
              flex: FlexForColumns.DATE,
              cellClassName: "number-cell",
            },
            {
              headerName: "End Date.",
              field: StockEntryTable.INC_end_Date,
              headerAlign: HEADER_TEXT_ALIGN,
              hideable: false,
              flex: FlexForColumns.DATE,
              cellClassName: "number-cell",
            },
            {
              headerName: "Stock Location",
              field: StockEntryTable.Stock_Location,
              headerAlign: HEADER_TEXT_ALIGN,
              hideable: false,
              flex: FlexForColumns.DESCRIPTION,
            },
          ],
        },
      },
      stockBalance: {
        List: [
          {
            headerName: "SL No.",
            field: "id",
            cellClassName: "number-cell",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.SLNO,
          },
          {
            headerName: "Code",
            field: "code",
            headerAlign: HEADER_TEXT_ALIGN,
            hideable: false,
            cellClassName: "td-link number-cell",
            flex: FlexForColumns.CODE,
          },
          {
            headerName: "Description",
            field: "description",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
          },
          {
            headerName: "UOM",
            field: "uom",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },
          {
            headerName: "Group",
            field: "group",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },
          {
            headerName: "Category",
            field: "category",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },
          {
            headerName: "Manufacturer",
            field: "manufacturer",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },
          {
            headerName: "Stock / Services",
            field: "stock_services",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },
          {
            headerName: "HSN Code",
            field: "hsn",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.CODE,
          },
          {
            headerName: "GST %",
            field: "gst_percentage",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.PERCENTAGE,
            cellClassName: "number-cell",
          },
          {
            headerName: "Locations",
            field: "locations",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
          },
          {
            headerName: companyLabel,
            field: "main_store",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },
          {
            headerName: subsidiaryLabel,
            field: "sub_store",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },
          {
            headerName: "Stock In Hand",
            field: "stock_in_hand",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
          },
          {
            headerName: "Total",
            field: "total",
            headerAlign: HEADER_TEXT_ALIGN,
            cellClassName: "font-green number-cell",
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
          },
        ],
        LocationDetails: [
          {
            headerName: "SL No.",
            field: "id",
            cellClassName: "number-cell",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.SLNO,
          },
          {
            headerName: "Location Name",
            field: "location_name",
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
            hideable: false,
          },
          {
            headerName: "Total Stocks",
            field: "total",
            headerAlign: HEADER_TEXT_ALIGN,
            align: AMOUNT_TEXT_ALIGN,
            flex: FlexForColumns.NUMBER,
            cellClassName: "number-cell",
          },
          {
            headerName: "Actions",
            field: "actions",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.ACTION_BUTTON,
          },
        ],
      },
    },
    Customers_Table: {
      List: [
        {
          headerName: "Sl",
          cellClassName: "number-cell",
          field: "id",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.SLNO,
        },
        {
          headerName: "Customer Name",
          cellClassName: "td-name td-onClick",
          field: "name",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.DESCRIPTION,
          hideable: false,
        },
        {
          headerName: "Address",
          field: "address",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.DESCRIPTION,
        },
        {
          headerName: "Email",
          field: "email",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.SUB_DESC,
        },
        {
          headerName: "Mobile",
          field: "mobile",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.MOBILE_NO,
          cellClassName: "number-cell",
        },
        {
          headerName: "Contact Person",
          field: "contactPerson",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.CONTACT_PERSON,
        },
        {
          headerName: "PAN",
          field: "panNo",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.GST_N0,
          cellClassName: "number-cell",
        },
        {
          headerName: "GST",
          field: "gst",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.GST_N0,
          cellClassName: "number-cell",
        },
      ],
    },
    Users: {
      List: [
        {
          headerName: "Sl",
          cellClassName: "number-cell",
          field: "id",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.SLNO,
        },
        {
          headerName: "Name",
          cellClassName: "td-link",
          field: "name",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.DESCRIPTION,
          hideable: false,
        },
        {
          headerName: "Mobile",
          field: "mobile",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.MOBILE_NO,
          cellClassName: "number-cell",
        },
        {
          headerName: "Email",
          field: "email",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.EMAIL,
        },
        {
          headerName: "Company",
          field: "company",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.EMAIL,
        },
        {
          headerName: "Subsidiary",
          field: "subsidiary",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.EMAIL,
        },
        {
          headerName: "Site",
          field: "site",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.EMAIL,
        },
        {
          headerName: "User Type",
          field: "user_type",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.SUB_DESC,
        },
      ],
      Configurations: [
        {
          headerName: "Sl",
          cellClassName: "number-cell",
          field: "id",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.SLNO,
        },
        {
          headerName: "Emp Id",
          cellClassName: "number-cell",
          field: "emp_id",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.CODE,
        },
        {
          headerName: "Name",
          cellClassName: "td-link",
          field: "emp_name",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.DESCRIPTION,
          hideable: false,
        },
        {
          headerName: "Mobile",
          field: "mobile",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.MOBILE_NO,
        },
        {
          headerName: "Table Type",
          field: "tableLevel",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.MOBILE_NO,
        },
        {
          headerName: "User Type",
          field: "user_type",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.CONTACT_PERSON,
        },
      ],
      UserLoginState: [
        {
          headerName: "Sl",
          cellClassName: "number-cell",
          field: "id",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.SLNO,
        },
        {
          headerName: "Name",
          cellClassName: "td-link",
          field: "name",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.DESCRIPTION,
          hideable: false,
        },
        {
          headerName: "Mobile",
          field: "mobile",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.MOBILE_NO,
          cellClassName: "number-cell",
        },
        {
          headerName: "Email",
          field: "email",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.EMAIL,
        },
        {
          headerName: "User Type",
          field: "user_type",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.SUB_DESC,
        },
        {
          headerName: "Login Status",
          field: "isLoginCreated",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.SUB_DESC,
        },
      ],
    },
    UserRightsConfig: {
      List: [
        {
          headerName: "",
          cellClassName: "td-link number-cell",
          field: "checkbox",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.SLNO,
        },
        {
          headerName: "Sl",
          cellClassName: "number-cell",
          field: "id",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.SLNO,
        },
        {
          headerName: "Name",
          cellClassName: "td-link",
          field: "name",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.DESCRIPTION,
          hideable: false,
        },
      ],
    },

    Rfqs: {
      ItemListModal: [
        {
          headerName: "Sl",
          cellClassName: "number-cell",
          field: "id",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.SLNO,
        },
        {
          headerName: itemLabel,
          field: "item_desc",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.SUB_DESC,
        },
        {
          headerName: "Description Send for RFQ",
          field: "udfItemDesc",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.SUB_DESC,
        },
        {
          headerName: "UOM",
          field: "uom",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.SUB_DESC,
        },
        {
          headerName: "Present Stock",
          field: "presentStk",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.NUMBER,
          cellClassName: "number-cell",
        },
        {
          headerName: "Approx Rate",
          field: "approxRate",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.NUMBER,
          cellClassName: "number-cell",
        },
        {
          headerName: "Accept Qty",
          field: "acceptQty",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.NUMBER,
          cellClassName: "number-cell",
        },
        {
          headerName: "Approx Taxable Value Qty",
          field: "taxable",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.NUMBER,
          cellClassName: "number-cell",
        },
        {
          headerName: "Tax",
          field: "tax",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.NUMBER,
          cellClassName: "number-cell",
        },
        {
          headerName: "Taxes Value",
          field: "taxvalue",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.NUMBER,
          cellClassName: "number-cell",
        },
        {
          headerName: "Approx Net Value",
          field: "netvalue",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.NUMBER,
          cellClassName: "number-cell",
        },
      ],
    },
    Items: {
      List: [
        {
          headerName: "Sl",
          flex: FlexForColumns.SLNO,
          cellClassName: "nuber-cell",
          field: "id",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
        },
        {
          headerName: "Code",

          field: "code",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.SUB_DESC,
        },
        {
          headerName: "Description",
          field: "description",
          headerAlign: HEADER_TEXT_ALIGN,
          hideable: false,
          flex: FlexForColumns.DESCRIPTION,
        },
        {
          headerName: "Group",
          flex: FlexForColumns.SUB_DESC,
          field: "group",
          headerAlign: HEADER_TEXT_ALIGN,
        },
        {
          headerName: "Category",
          flex: FlexForColumns.SUB_DESC,
          field: "category",
          headerAlign: HEADER_TEXT_ALIGN,
        },
        {
          headerName: "Model",
          flex: FlexForColumns.SUB_DESC,
          field: "model",
          headerAlign: HEADER_TEXT_ALIGN,
        },
        {
          headerName: "Unit of Measurement",
          flex: FlexForColumns.SUB_DESC,
          field: "uom",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
        },
        {
          headerName: "OB",
          flex: FlexForColumns.SUB_DESC,
          field: "ob",
          headerAlign: HEADER_TEXT_ALIGN,
          align: AMOUNT_TEXT_ALIGN,
        },
        // {
        //   headerName: "Total Asset",
        //   flex: FlexForColumns.SUB_DESC,
        //   field: "total_asset",
        //   headerAlign: HEADER_TEXT_ALIGN,
        //   align: AMOUNT_TEXT_ALIGN,
        // },
        {
          headerName: "Action",
          flex: FlexForColumns.ACTION_BUTTON,
          field: "actions",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
        },
      ],
      List2: [
        {
          headerName: "Sl",
          flex: FlexForColumns.SLNO,
          cellClassName: "nuber-cell",
          field: "id",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
        },

        {
          headerName: "Description",
          field: "description",
          headerAlign: HEADER_TEXT_ALIGN,
          hideable: false,
          flex: FlexForColumns.DESCRIPTION,
        },
        {
          headerName: companyLabel,
          field: "currentCompany",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.SUB_DESC,
        },
        {
          headerName: subsidiaryLabel,
          field: "currentSubsidiary",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.SUB_DESC,
        },
        {
          headerName: subsidiarySiteLabel,
          field: "currentSite",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.SUB_DESC,
        },
      ],
      ItemDetailsList: [
        {
          headerName: "Sl",
          flex: FlexForColumns.SLNO,
          cellClassName: "nuber-cell",
          field: "id",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
        },
        {
          headerName: "Description",
          field: "description",
          headerAlign: HEADER_TEXT_ALIGN,
          hideable: false,
          flex: FlexForColumns.DESCRIPTION,
        },
        {
          headerName: "Serial No",
          flex: FlexForColumns.SUB_DESC,
          cellClassName: "nuber-cell",
          field: "prodSerialNo",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
        },
        {
          headerName: "Pole No",
          flex: FlexForColumns.SUB_DESC,
          cellClassName: "nuber-cell",
          field: "poleNum",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
        },
        {
          headerName: "Brand",
          flex: FlexForColumns.SUB_DESC,
          cellClassName: "nuber-cell",
          field: "prodBrand",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
        },
        {
          headerName: "MaintainedBy",
          flex: FlexForColumns.SUB_DESC,
          cellClassName: "nuber-cell",
          field: "maintainedBy",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
        },
        {
          headerName: "Warranty Start Date",
          flex: FlexForColumns.SUB_DESC,
          cellClassName: "nuber-cell",
          field: "prodWarrantyStartDate",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
        },
        {
          headerName: "Warranty End Date",
          flex: FlexForColumns.SUB_DESC,
          cellClassName: "nuber-cell",
          field: "prodWarrantyEndDate",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
        },
        {
          headerName: "Installation Date",
          flex: FlexForColumns.SUB_DESC,
          cellClassName: "nuber-cell",
          field: "prodInstallationEndDate",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
        },
        {
          headerName: "Amc Start Date",
          flex: FlexForColumns.SUB_DESC,
          cellClassName: "nuber-cell",
          field: "prodAmcStDate",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
        },
        {
          headerName: "Amc End Date",
          flex: FlexForColumns.SUB_DESC,
          cellClassName: "nuber-cell",
          field: "prodAmcEndDate",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
        },
        {
          headerName: "Address",
          flex: FlexForColumns.SUB_DESC,
          cellClassName: "nuber-cell",
          field: "address",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
        },
        {
          headerName: "Geo Location",
          flex: FlexForColumns.SUB_DESC,
          cellClassName: "nuber-cell",
          field: "geoLocation",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
        },

        {
          headerName: "Group",
          flex: FlexForColumns.SUB_DESC,
          field: "group",
          headerAlign: HEADER_TEXT_ALIGN,
        },
        {
          headerName: "Category",
          flex: FlexForColumns.SUB_DESC,
          field: "category",
          headerAlign: HEADER_TEXT_ALIGN,
        },
        {
          headerName: "Model",
          flex: FlexForColumns.SUB_DESC,
          field: "model",
          headerAlign: HEADER_TEXT_ALIGN,
        },
        {
          headerName: "Unit of Measurement",
          flex: FlexForColumns.SUB_DESC,
          field: "uom",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
        },
       
       
      ],
    },
    Maps: {
      CompanyDetails: [
        {
          headerName: "Sl",
          field: "id",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.SLNO,
          cellClassName: "nuber-cell",
        },
        {
          headerName: `${subsidiaryLabel} Name`,
          field: "subsidiary_name",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.DESCRIPTION,
          hideable: false,
        },
        {
          headerName: `Total ${itemLabel} Available`,
          field: "total",
          headerAlign: HEADER_TEXT_ALIGN,
          align: AMOUNT_TEXT_ALIGN,
          flex: FlexForColumns.SUB_DESC,
        },
        {
          headerName: "Actions",
          field: "actions",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.ACTION_BUTTON,
          align: SLNO_TEXT_ALIGN,
        },
      ],
      ItemDetails: [
        {
          headerName: "Sl",
          field: "id",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.SLNO,
          cellClassName: "number-cell",
        },
        {
          headerName: "Code",
          field: "code",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.CODE,
        },
        {
          headerName: "Description",
          field: "description",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.DESCRIPTION,
          hideable: false,
        },
        {
          headerName: "Uom",
          field: "uom",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.SUB_DESC,
        },
        {
          headerName: "Group",
          field: "group",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.SUB_DESC,
        },
        {
          headerName: "Category",
          field: "category",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.SUB_DESC,
        },
        {
          headerName: "Manufacturer",
          field: "manufacturer",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.SUB_DESC,
        },
        {
          headerName: `Total ${itemLabel} Available`,
          field: "total",
          headerAlign: HEADER_TEXT_ALIGN,
          align: AMOUNT_TEXT_ALIGN,
          cellClassName: "font-green",
          flex: FlexForColumns.SUB_DESC,
        },
        {
          headerName: "Actions",
          field: "actions",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.ACTION_BUTTON,
          align: SLNO_TEXT_ALIGN,
        },
      ],
      RaisedTicketDetails: [
        {
          headerName: "Sl",
          cellClassName: "number-cell",
          field: "id",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.SLNO,
        },
        {
          headerName: "Ticket No",
          cellClassName: "td-link",
          field: "logNo",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.SUB_DESC,
          hideable: false,
        },
        {
          headerName: "Created Date",
          field: "ticket_date",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.SUB_DESC,
          cellClassName: "number-cell",
        },
        {
          headerName: companyLabel,
          field: "company",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.SUB_DESC,
        },
        {
          headerName: subsidiaryLabel,
          field: "subsidiary",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.SUB_DESC,
        },
        {
          headerName: subsidiarySiteLabel,
          field: "subsidiary_site",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.SUB_DESC,
        },
        {
          headerName: junctionLabel,
          field: "junction",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.SUB_DESC,
        },
        {
          headerName: itemLabel,
          field: "asset",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.DESCRIPTION,
        },
{
          headerName: "Address",
          field: "address",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.DESCRIPTION,
        },
        {
          headerName: "Pole Number",
          field: "poleNum",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.SLNO,
        },
        {
          headerName: "Reason",
          field: "ticket_reason",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.DESCRIPTION,
        },
        {
          headerName: "Maintained By",
          field: "maintained_by",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.CONTACT_PERSON,
        },

        // {
        //   headerName: "Resolved Date",
        //   field: "resolvedDate",
        //   headerAlign: HEADER_TEXT_ALIGN,
        //   align: "",
        //   flex: FlexForColumns.SUB_DESC,
        //   cellClassName: "number-cell"
        // },
        {
          headerName: "Closed Date",
          field: "closedDate",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.DATE,
          cellClassName: "number-cell",
        },
        {
          headerName: "Status",
          field: "ticket_status",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.SUB_DESC,
        },

        {
          headerName: `${itemLabel} SlNo`,
          field: "asset_slno",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.SUB_DESC,
          cellClassName: "number-cell",
        },

        {
          headerName: "Priority",
          field: "priority",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.SUB_DESC,
        },
        {
          headerName: "Resolved Duration (in Mins)",
          field: "resolvedDuration",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.DESCRIPTION,
        },
        {
          headerName: "Closed Duration (in Mins)",
          field: "closedDuration",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.DESCRIPTION,
        },
        {
          headerName: "Actions",
          field: "actions",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.SUB_DESC,
        },
      ],
    },
    Projects: {
      List: [
        {
          headerName: "Sl",
          cellClassName: "number-cell",
          field: "id",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.SLNO,
        },
        {
          headerName: "Project Name",
          cellClassName: "td-link",
          field: "name",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.DESCRIPTION,
          hideable: false,
        },
        {
          headerName: "Vendor",
          field: "vendor",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.SUB_DESC,
        },
        {
          headerName: "Project Start Date",
          field: "startDate",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.DATE,
        },
        {
          headerName: "Project End Date",
          field: "endDate",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.DATE,
        },
        {
          headerName: "Contract Value",
          field: "contractValue",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.SUB_DESC,
        },
        {
          headerName: "Go Live Date",
          field: "goLiveDate",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.SUB_DESC,
        },
          {
          headerName: "Is Meeting Active",
          field: "isMeetingActive",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.SUB_DESC,
        },
        {
          field: "actions",
          cellClassName: "td-actions-print ",
          headerClassName: "td-actions-print-header",
          headerAlign: HEADER_TEXT_ALIGN,
          align: MARKS_TEXT_ALIGN,
          headerName: TableHeaders.ACTION,
        },
      ],
    },
    ProjectExt: {
      List: [
        {
          headerName: "Sl",
          cellClassName: "number-cell",
          field: "id",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.SLNO,
        },
        {
          headerName: "Project Extension Name",
          cellClassName: "td-link",
          field: "name",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.DESCRIPTION,
          hideable: false,
        },
        {
          headerName: "Vendor",
          field: "vendor",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.SUB_DESC,
        },
        {
          headerName: "Project Extension Start Date",
          field: "startDate",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.DATE,
        },
        {
          headerName: "Project Extension End Date",
          field: "endDate",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.DATE,
        },
        {
          field: "actions",
          cellClassName: "td-actions-print ",
          headerClassName: "td-actions-print-header",
          headerAlign: HEADER_TEXT_ALIGN,
          align: MARKS_TEXT_ALIGN,
          headerName: TableHeaders.ACTION,
        },
      ],
    },
    ChallansList: [
      {
        headerName: "Sl",
        field: "id",
        headerAlign: HEADER_TEXT_ALIGN,
        align: SLNO_TEXT_ALIGN,
        flex: FlexForColumns.SLNO,
        cellClassName: "nuber-cell",
      },
      {
        headerName: "Date",
        field: "date",
        headerAlign: HEADER_TEXT_ALIGN,
        align: SLNO_TEXT_ALIGN,
        flex: 1,
        cellClassName: "nuber-cell",
        hideable: false,
      },
      {
        headerName: "StopLine",
        field: "stop_line",
        headerAlign: HEADER_TEXT_ALIGN,
        align: SLNO_TEXT_ALIGN,
        flex: FlexForColumns.DATE,
        cellClassName: "nuber-cell",
      },
      {
        headerName: "Seat Belt",
        field: "seat_belt",
        headerAlign: HEADER_TEXT_ALIGN,
        align: SLNO_TEXT_ALIGN,
        flex: FlexForColumns.DATE,
        cellClassName: "nuber-cell",
      },
      {
        headerName: "Jumping Traffic Signals",
        field: "jumping_traffic_signals",
        headerAlign: HEADER_TEXT_ALIGN,
        align: SLNO_TEXT_ALIGN,
        flex: FlexForColumns.DATE,
        cellClassName: "nuber-cell",
      },
      {
        headerName: "triple Riding",
        field: "triple_riding",
        headerAlign: HEADER_TEXT_ALIGN,
        align: SLNO_TEXT_ALIGN,
        flex: FlexForColumns.DATE,
        cellClassName: "nuber-cell",
      },
      {
        headerName: "No Helmet",
        field: "no_helmet",
        headerAlign: HEADER_TEXT_ALIGN,
        align: SLNO_TEXT_ALIGN,
        flex: FlexForColumns.DATE,
        cellClassName: "nuber-cell",
      },
      {
        headerName: "Over Speed",
        field: "over_speed",
        headerAlign: HEADER_TEXT_ALIGN,
        align: SLNO_TEXT_ALIGN,
        flex: FlexForColumns.DATE,
        cellClassName: "nuber-cell",
      },
      {
        headerName: "Driver on call",
        field: "driver_on_call",
        headerAlign: HEADER_TEXT_ALIGN,
        align: SLNO_TEXT_ALIGN,
        flex: FlexForColumns.DATE,
        cellClassName: "nuber-cell",
      },
      {
        headerName: "Total",
        field: "total",
        headerAlign: HEADER_TEXT_ALIGN,
        align: SLNO_TEXT_ALIGN,
        flex: FlexForColumns.DATE,
        cellClassName: "nuber-cell",
      },
    ],
    Reports: {
      Asset_Summary: [
        {
          headerName: "Sl",
          cellClassName: "number-cell",
          field: "id",

          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.SLNO,
        },
        {
          headerName: companyLabel,
          cellClassName: "number-cell",
          field: "company",
          hideable: false,
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.DESCRIPTION,
        },

        {
          headerName: `Total No. of ${itemLabel}`,
          cellClassName: "number-cell",
          field: "total_asset",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.SUB_DESC,
        },

        {
          headerName: "Working",
          field: "working",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.SUB_DESC,
        },
        {
          headerName: "Tickets Raised",
          field: "not_working",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.SUB_DESC,
        },

        {
          headerName: "Action",
          field: "action",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.ACTION,
        },
      ],
      VendorWiseJunctions: [
        {
          headerName: "Sl",
          cellClassName: "number-cell",
          field: "id",

          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.SLNO,
        },
        {
          headerName: `${junctionLabel} No.`,

          field: "junc_no",

          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.CODE,
        },
        {
          headerName: `${junctionLabel}'s`,

          field: "junc_desc",
          hideable: false,
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.DESCRIPTION,
        },
        {
          headerName: `${junctionLabel} Alias`,

          field: "junc_alias",

          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.DESCRIPTION,
        },

        {
          headerName: companyLabel,

          field: "company",

          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.SUB_DESC,
        },
        {
          headerName: subsidiaryLabel,

          field: "subsidiary",

          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.SUB_DESC,
        },
        {
          headerName: subsidiarySiteLabel,

          field: "subsidiary_site",

          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.SUB_DESC,
        },
        {
          headerName: `${junctionLabel} Type`,

          field: "junc_type",

          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.DESCRIPTION,
        },
        {
          headerName: `${junctionLabel} Status`,

          field: "status",

          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.DESCRIPTION,
        },
        {
          headerName: `Status`,
          field: "ticketStatus",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.DESCRIPTION,
        },
        {
          headerName: "Action",

          field: "actions",

          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.DESCRIPTION,
        },
      ],
      JunctionType: [
        {
          headerName: "Sl",
          cellClassName: "number-cell",
          field: "id",

          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.SLNO,
        },
        {
          headerName: `Type of${junctionLabel}'s`,
          field: "type_of_signal",
          hideable: false,
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.DESCRIPTION,
        },
        {
          headerName: `Total No. of${itemLabel}'s`,
          field: "total_no_of_asset",
          cellClassName: "number-cell",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.CODE,
          align: AMOUNT_TEXT_ALIGN,
        },
        {
          headerName: "Working",
          field: "working",
          cellClassName: "number-cell",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.SUB_DESC,
          align: AMOUNT_TEXT_ALIGN,
        },
        {
          headerName: "Tickets Raised",
          field: "not_working",
          cellClassName: "number-cell",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.SUB_DESC,
          align: AMOUNT_TEXT_ALIGN,
        },
        {
          headerName: "Planned",
          field: "planned",
          cellClassName: "number-cell",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.SUB_DESC,
          align: AMOUNT_TEXT_ALIGN,
        },
        {
          headerName: "Work In Progress",
          field: "in_progress",
          cellClassName: "number-cell",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.SUB_DESC,
          align: AMOUNT_TEXT_ALIGN,
        },
        {
          headerName: "Installed",
          field: "installed",
          cellClassName: "number-cell",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.SUB_DESC,
          align: AMOUNT_TEXT_ALIGN,
        },
        {
          headerName: "Shifting",
          field: "shifting",
          cellClassName: "number-cell",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.SUB_DESC,
          align: AMOUNT_TEXT_ALIGN,
        },
        {
          headerName: "Commissioned",
          field: "commissioned",
          cellClassName: "number-cell",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.SUB_DESC,
          align: AMOUNT_TEXT_ALIGN,
        },
        {
          headerName: "Decommissioned",
          field: "decommissioned",
          cellClassName: "number-cell",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.SUB_DESC,
          align: AMOUNT_TEXT_ALIGN,
        },
        {
          headerName: "Actions",
          field: "actions",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.DESCRIPTION,
          align: SLNO_TEXT_ALIGN,
        },
      ],
    },
    MinutesOfMeeting: {
      Attenadance: [
        {
          headerName: "Sl",
          cellClassName: "number-cell",
          field: "id",

          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.SLNO,
        },
        {
          headerName: "Employee Name",
          field: "employee_name",
          hideable: false,
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.SLNO,
        },
        {
          headerName: "User Type",
          field: "user_type",

          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.SUB_DESC,
        },
        {
          headerName: "Vendor Name",
          field: "vendor_name",

          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.SUB_DESC,
        },
        {
          headerName: "Status",
          field: "status",

          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.STATUS,
        },
      ],
      Attended: [
        {
          headerName: "Sl",
          cellClassName: "number-cell",
          field: "id",

          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.SLNO,
        },
        {
          headerName: "Employee Name",
          field: "employee_name",
          hideable: false,
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.SLNO,
        },
        {
          headerName: "User Type",
          field: "user_type",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.SLNO,
        },
        {
          headerName: "Status",
          field: "status",

          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.STATUS,
        },
      ],
    },
    Calibration: {
      List: [
        {
          headerName: "Sl",
          cellClassName: "number-cell",
          field: "id",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.SLNO,
        },
        {
          headerName: "Serial No",
          cellClassName: "number-cell",
          field: "serial_no",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.DESCRIPTION,
          hideable: false,
        },
        {
          headerName: "Blow Date",
          cellClassName: "number-cell",
          field: "blow_date",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.DESCRIPTION,
          hideable: false,
        },
        {
          headerName: "Blow Count to Reach Calibration",
          cellClassName: "number-cell",
          field: "blow_count",

          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.DESCRIPTION,
        },
        {
          headerName: "Blow Count",
          cellClassName: "number-cell",
          field: "blow_count_to_view",

          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.DESCRIPTION,
        },
        {
          headerName: "Total Times Calibrated",
          cellClassName: "number-cell",
          field: "total_times",

          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.SLNO,
        },
        {
          headerName: "Enter Blow Count",
          cellClassName: "number-cell",
          field: "enter_blow_count",

          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.SUB_DESC,
        },
        {
          headerName: "Action",
          cellClassName: "number-cell",
          field: "actions",

          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.SUB_DESC,
        },
      ],
    },
    WorkInProgress: {
      ProjectStatus: [
        {
          headerName: "Sl",
          cellClassName: "number-cell",
          field: "id",

          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.SLNO,
        },
        {
          headerName: "Date",
          cellClassName: "number-cell",
          field: "date",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.DATE,
          hideable: false,
        },
        {
          headerName: "Remarks",
          field: "pmu_remarks",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.DESCRIPTION,
          hideable: false,
        },
        {
          headerName: "Action",
          field: "actions",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.SLNO,
          hideable: true,
        },
      ],
    },
    ParticularAsset: {
      AssetList: [
        {
          headerName: "Sl",
          cellClassName: "number-cell",
          field: "id",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.SLNO,
        },
        {
          headerName: "Serial No",
          cellClassName: "number-cell",
          field: "sl_no",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.DATE,
          hideable: false,
        },
        {
          headerName: "Zones",
          field: "zones",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.DESCRIPTION,
          hideable: false,
        },
        {
          headerName: "Sub-Division",
          field: "sub_division",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.SUB_DESC,
          hideable: true,
        },
        {
          headerName: "Police Station",
          field: "police_station",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.SUB_DESC,
          hideable: true,
        },
        {
          headerName: "Signals",
          field: "signals",
          headerAlign: HEADER_TEXT_ALIGN,
          flex: FlexForColumns.SUB_DESC,
          hideable: true,
        },
        {
          headerName: "Status",
          field: "status",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.SUB_DESC,
          hideable: true,
        },
        {
          headerName: "Action",
          field: "action",
          headerAlign: HEADER_TEXT_ALIGN,
          align: SLNO_TEXT_ALIGN,
          flex: FlexForColumns.ACTION_BUTTON,
          hideable: true,
        },
      ],
    },
    MoveItemDetailsList: {
      List: [
        {
          headerName: "Serial Number",
          cellClassName: "td-link",
          field: "serial_no",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.DESCRIPTION,
          hideable: false,
        },
        {
          headerName: "Item Desc",
          cellClassName: "td-link",
          field: "itemDesc",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.DESCRIPTION,
          hideable: false,
        },
        {
          headerName: "Address",
          cellClassName: "td-link",
          field: "address",
          headerAlign: HEADER_TEXT_ALIGN,
          align: "",
          flex: FlexForColumns.DESCRIPTION,
          hideable: false,
        },
      ],
    },
  };
  return tableJson;
};

export default useAssetTableJson;
